import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconFirstPage, IconLastPage, IconChevronLeft, IconChevronRight } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { forwardRef } from 'react';
import { Button } from '../../../primitives/Pagination/Item/components/Button.js';
import { Ellipsis } from '../../../primitives/Pagination/Item/components/Ellipsis.js';
export const Item = /*#__PURE__*/_styled(forwardRef(({
  type,
  page,
  selected,
  disabled,
  label,
  variant = 'interaction',
  size = 'medium',
  ...restProps
}, ref) => {
  const {
    t
  } = useTranslation();
  // @ts-expect-error TS(2339) FIXME: Property 'end-ellipsis' does not exist on type '{ ... Remove this comment to see the full error message
  const icon = {
    first: _jsx(IconFirstPage, {}),
    previous: _jsx(IconChevronLeft, {}),
    next: _jsx(IconChevronRight, {}),
    last: _jsx(IconLastPage, {})
  }[type];
  // @ts-expect-error TS(2339) FIXME: Property 'end-ellipsis' does not exist on type '{ ... Remove this comment to see the full error message
  const iconPosition = {
    first: 'left',
    previous: 'left',
    next: 'right',
    last: 'right'
  }[type];
  return type === 'start-ellipsis' || type === 'end-ellipsis' ?
  // @ts-expect-error TS(2322) FIXME: Type '{ children: string; ref: ForwardedRef<HTMLEl... Remove this comment to see the full error message
  _jsx(Ellipsis, {
    ...restProps,
    ref: ref,
    "data-type": type,
    children: "\u2026"
  }) : _jsx(Button, {
    ...restProps,
    // @ts-expect-error FIXME
    ref: ref,
    category: selected ? 'primary' : 'tertiary',
    variant: variant,
    size: size,
    icon: icon,
    // @ts-expect-error FIXME
    iconPosition: iconPosition,
    disabled: disabled,
    "data-type": type,
    "aria-label": `${t(`pagination:${type}`)}
            ${type === 'page' ? ` ${page}` : ``}`,
    children: type === 'page' ? page : label
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1o6fvlm0"
} : {
  target: "e1o6fvlm0",
  label: "Item"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");